import React, { FC } from 'react';
import SideMenu from 'features/feature-aside-menu';
import { Wrapper } from './styles';
import SpecializationMetrics from 'features/feature-specialization-metrics';

const SpecializationMetricsPage: FC = () => (
  <Wrapper>
    <SideMenu />
    <SpecializationMetrics />
  </Wrapper>
);

export default SpecializationMetricsPage;
